import { useState, useEffect } from 'react'
import { getPersonasConFuncion } from '../../api/client'
import { formatFecha } from '../unidades/tipos'

// Permisos > click on a function: everyone who holds it today and why (by name, by cargo, as one of an area's
// people or its head, as a user, or by a legacy role). `t` is the "operations" translator.
export default function PersonasConFuncion({ funcion, titulo, descripcion, onClose, t }) {
  const [lista, setLista] = useState(null)
  const [err, setErr] = useState('')
  const [q, setQ] = useState('')

  useEffect(() => {
    let vivo = true
    getPersonasConFuncion(funcion).then(r => vivo && setLista(r))
      .catch(e => vivo && setErr(e.response?.data?.detail || t('ot.permisos.personas.fallo')))
    return () => { vivo = false }
  }, [funcion, t])

  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', h)
    return () => window.removeEventListener('keydown', h)
  }, [onClose])

  const motivo = (m) => {
    const [tipo, ...resto] = m.split(':')
    const nombre = resto.join(':')
    return tipo === 'persona' || tipo === 'usuario' ? t(`ot.permisos.personas.motivo.${tipo}`)
      : t(`ot.permisos.personas.motivo.${tipo}`, { nombre })
  }
  const visibles = (lista || []).filter(p => !q.trim() || `${p.nombre} ${p.cargo || ''} ${p.email || ''}`.toLowerCase().includes(q.trim().toLowerCase()))

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[85vh] flex flex-col p-5 gap-3" role="dialog" aria-label={titulo}>
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 first-letter:uppercase">{titulo}</h2>
            <p className="text-sm text-gray-500">{descripcion}</p>
          </div>
          <button onClick={onClose} className="text-sm text-gray-500 hover:text-gray-800 shrink-0">{t('ot.permisos.personas.cerrar')} ✕</button>
        </div>
        {err && <p className="text-sm text-red-600">{err}</p>}
        {lista == null && !err && <p className="text-sm text-gray-400">{t('common:actions.loading')}</p>}
        {lista && (
          <>
            <div className="flex items-center justify-between gap-3">
              <span className="text-sm text-gray-600">{t('ot.permisos.personas.total', { count: lista.length })}</span>
              {lista.length > 8 && (
                <input value={q} onChange={e => setQ(e.target.value)} placeholder={t('ot.permisos.personas.buscar')}
                  className="border border-gray-200 rounded-lg px-3 py-1.5 text-sm w-56 focus:outline-none focus:ring-2 focus:ring-gray-200" />
              )}
            </div>
            <div className="overflow-y-auto min-h-0 flex-1 border border-gray-100 rounded-lg">
              {visibles.length === 0 ? <p className="p-4 text-sm text-gray-400">{t('ot.permisos.personas.nadie')}</p> : (
                <ul>
                  {visibles.map(p => (
                    <li key={`${p.persona_id}-${p.usuario_id}`} className="px-4 py-2.5 border-t first:border-t-0 border-gray-100">
                      <div className="flex items-center justify-between gap-3">
                        <div className="min-w-0">
                          <span className="font-medium text-gray-900">{p.nombre}</span>
                          {p.cargo && <span className="text-sm text-gray-500"> · {p.cargo}</span>}
                          {p.email && <div className="text-xs text-gray-400 truncate">{p.email}</div>}
                        </div>
                        {!p.tiene_cuenta && (
                          <span className="text-[11px] rounded-full bg-gray-100 text-gray-600 px-2 py-0.5 shrink-0" title={t('ot.permisos.personas.sinCuentaHint')}>
                            {t('ot.permisos.personas.sinCuenta')}
                          </span>
                        )}
                      </div>
                      <div className="mt-1 flex flex-wrap items-center gap-1.5">
                        {p.motivos.map(m => (
                          <span key={m} className="text-[11px] rounded-full bg-indigo-50 text-indigo-700 px-2 py-0.5">{motivo(m)}</span>
                        ))}
                        {p.revision && <span className="text-[11px] rounded-full bg-amber-50 text-amber-700 px-2 py-0.5">{t('ot.permisos.personas.revisar', { fecha: formatFecha(p.revision) })}</span>}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
